<template>
  <section>
    <va-modal
      ref="createOrUpdateHearingLossRules"
      :value="isOpen"
      :okText="$t('modals.buttons.save')"
      :cancelText="$t('modals.buttons.back')"
      :dangerText="$t('modals.buttons.delete')"
      :showDelete="isUpdate"
      @remove="onDelete"
      @ok="submitForm"
      @cancel="onCancel"
    >
      <div slot="header" class="modal-title">
        <span>{{ isUpdate ? $t('rules.edit'): $t('rules.create') }}</span>
      </div>

      <form class="evollu-form">
        <table class="table is-narrow">
          <thead>
            <tr>
              <th>{{$t('rules.labels.type') }}</th>
              <th>{{$t('rules.labels.comparator')}}</th>
              <th>{{$t('rules.labels.value')}} {{$t('rules.labels.value_between')}}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(type, index) in ['teste_auditivo', 'questionario']" :key="index">
              <td class="align-middle">
                <span v-if="type === 'teste_auditivo'"> {{ $t('hearinglossrules.labels.hearing_test') }}</span>
                <span v-if="type === 'questionario'"> {{ $t('hearinglossrules.labels.questionaire') }} </span>
              </td>
              <td>
                <span class="select">
                  <template v-if="index === 0">
                    <select class="custom-select" v-model="form.data.threshold_type">
                      <option value="0">{{$t('hearinglossrules.labels.threshold_type.0')}}</option>
                      <option value="1">{{$t('hearinglossrules.labels.threshold_type.1')}}</option>
                      <option value="2">{{$t('hearinglossrules.labels.threshold_type.2')}}</option>
                      <option value="3">{{$t('hearinglossrules.labels.threshold_type.3')}}</option>
                    </select>
                  </template>
                  <template v-else>
                    <span style="padding-left: 12px;">{{ $t('hearinglossrules.labels.>=') }}</span>
                  </template>
                </span>
              </td>
              <td>
                <div class="form-group form-group-value">
                  <div class="input-group">
                    <template v-if="index === 0">
                      <va-input
                        id="threshold-input"
                        v-model="form.data.threshold"
                        type="number"
                        step="5"
                        min="0"
                        max="100"
                      />
                    </template>
                    <template v-else>
                      <va-input
                        id="min-quest-value-input"
                        v-model="form.data.min_quest_value"
                        type="number"
                        step="5"
                        min="0"
                        max="100"
                      />
                    </template>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <va-checkbox
          :id="'checkbox_diagnosed_hl'"
          :isCircle="true"
          v-model="form.data.diagnosed_hl"
          :label="$t('hearinglossrules.labels.diagnosed_hl_full')">
        </va-checkbox>

        <va-checkbox
          :id="'checkbox_hearing_aid'"
          :isCircle="true"
          v-model="form.data.hearing_aid"
          :label="$t('hearinglossrules.labels.hearing_aid_full')"
        />
      </form>
    </va-modal>

    <ConfirmationModal
      v-if="isDeletingRule"
      :title="$t('hearinglossrules.delete_rule')"
      :body="$t('hearinglossrules.delete_message')"
      @modal-canceled="cancel"
      @modal-confirmed="confirmDelete"
    />

  </section>

</template>
<script>
import { HearingLossRulesService } from '@/api/LeadsService'
import ConfirmationModal from '@/components/common/ConfirmationModal'
export default {
  props: {
    hearingLossRule: {
      type: Object,
      required: false
    },
    entity: {
      type: Object,
      required: true
    }
  },
  components: {
    ConfirmationModal
  },
  computed: {
    isUpdate: function () {
      return this.hearingLossRule !== null && this.hearingLossRule !== undefined
    },
    invalidQuestionnaireValue: function () {
      return this.form.data.quest_value === '' || this.form.data.quest_value < 0 || this.form.data.quest_value > 100
    },
    invalidHearingTestValue: function () {
      return this.form.data.ht_value === '' || this.form.data.ht_value < 0 || this.form.data.ht_value > 100
    }
  },
  data: function () {
    return {
      isOpen: false,
      isDeletingRule: false,
      form: {
        data: {
          threshold_type: '0',
          threshold: 0,
          min_quest_value: 0,
          diagnosed_hl: false,
          hearing_aid: false
        }
      }
    }
  },
  created: function () {
    if (this.isUpdate) {
      this.prepareForUpdate()
    }
  },
  mounted: function () {
    this.isOpen = true
  },
  methods: {
    prepareForUpdate: function () {
      this.form.data = JSON.parse(JSON.stringify(this.hearingLossRule))
      this.form.data.diagnosed_hl = !!this.form.data.diagnosed_hl
      this.form.data.hearing_aid = !!this.form.data.hearing_aid
    },
    submitForm: function () {
      let data = this.getFormData()

      if (data) {
        if (this.isUpdate) {
          HearingLossRulesService.update(this.entity.id, this.hearingLossRule.id, data)
            .then(hearingLossRule => {
              this.showToast(this.$t('hearinglossrules.rule_updated'), this.$store.state.successToastOptions)
              this.$emit('rule-updated', { hearingLossRule })
              this.$refs.createOrUpdateHearingLossRules.cancel()
            })
            .catch(errors => {
              console.log(errors)
              this.showToast(this.$t('hearinglossrules.something_went_wrong'), this.$store.state.errorToastOptions)
            })
        } else {
          HearingLossRulesService.store(this.entity.id, data)
            .then(hearingLossRule => {
              this.showToast(this.$t('hearinglossrules.rule_created'), this.$store.state.successToastOptions)
              this.$emit('rule-created', { hearingLossRule })
              this.$refs.createOrUpdateHearingLossRules.cancel()
            })
            .catch(errors => {
              console.log(errors)
              this.showToast(this.$t('hearinglossrules.something_went_wrong'), this.$store.state.errorToastOptions)
            })
        }
      }
    },
    getFormData: function () {
      if (this.invalidQuestionnaireValue) {
        this.showToast(this.$t('rules.errors.invalid_questionnaire'), this.$store.state.errorToastOptions)
        return
      }

      if (this.invalidHearingTestValue) {
        this.showToast(this.$t('rules.errors.invalid_hearing_test'), this.$store.state.errorToastOptions)
        return
      }

      let body = {}

      if (!this.isUpdate || (this.isUpdate && this.hearingLossRule.threshold !== this.form.data.threshold)) {
        body.threshold = this.form.data.threshold
      }

      if (!this.isUpdate || (this.isUpdate && this.hearingLossRule.threshold_type !== this.form.data.threshold_type)) {
        body.threshold_type = this.form.data.threshold_type
      }

      if (!this.isUpdate || (this.isUpdate && this.hearingLossRule.min_quest_value !== this.form.data.min_quest_value)) {
        body.min_quest_value = this.form.data.min_quest_value
      }

      if (!this.isUpdate || (this.isUpdate && !!this.hearingLossRule.diagnosed_hl !== this.form.data.diagnosed_hl)) {
        body.diagnosed_hl = this.form.data.diagnosed_hl
      }

      if (!this.isUpdate || (this.isUpdate && !!this.hearingLossRule.hearing_aid !== this.form.data.hearing_aid)) {
        body.hearing_aid = this.form.data.hearing_aid
      }

      return body
    },
    onDelete: function () {
      this.isOpen = false
      this.isDeletingRule = true
    },
    cancelDelete: function () {
      this.isDeletingRule = false
      this.isOpen = true
    },
    confirmDelete: function () {
      HearingLossRulesService.destroy(this.entity.id, this.hearingLossRule.id)
        .then(() => {
          this.showToast(this.$t('hearinglossrules.rule_deleted'), this.$store.state.successToastOptions)
          this.$emit('rule-deleted', { hearingLossRule: this.hearingLossRule })
          this.cancelDelete()
          this.$refs.createOrUpdateHearingLossRules.cancel()
        })
        .catch(errors => {
          console.log(errors)
          this.cancelDelete()
          this.showToast(this.$t('hearinglossrules.something_went_wrong'), this.$store.state.errorToastOptions)
        })
    },
    onCancel: function () {
      this.isOpen = false
      setTimeout(() => {
        this.$emit('cancel')
      }, 500)
    }
  }
}
</script>
